import { LuClock } from "react-icons/lu";
import { getChangeAdminStage } from "../../../../data/flight/order/getChangeAdminGuidance";

function ChangeConfirmationRequestProgress({ data }) {
  const steps = [
    "Request received",
    "Review",
    "Quote",
    "Agent accept",
    "Payment",
    "Airline submission",
    "Re-issue",
    "Completed",
  ];

  const stage = getChangeAdminStage(data);
  const activeByStage = {
    needs_review: 2,
    auto_processing: 3,
    needs_quote: 3,
    awaiting_agent: 4,
    awaiting_payment: 5,
    quote_expired: 3,
    quote_expired_closed: 3,
    needs_airline_submit: 6,
    send_failed: 6,
    awaiting_supplier: 6,
    needs_reissue: 7,
    settlement_failed: 7,
    failure_settling: 7,
    completed: 8,
    declined: 2,
    failed: 6,
    supplier_failed: 6,
    validation_failed: 1,
    failure_settled: 6,
    unknown: 1,
  };
  const activeStep = activeByStage[stage] || 1;

  return (
    <div className="w-full bg-white px-6 py-4 border border-gray-200 rounded-xl shadow-sm hidden lg:flex flex-col justify-between items-center mt-4 gap-3">
      <div className="w-full flex justify-between  items-center">
        {steps.map((label, index) => {
          const stepNum = index + 1;
          const isActive = stepNum === activeStep;
          const isCompleted = stepNum < activeStep;

          return (
            <div
              key={label}
              className="flex-1 flex flex-col items-center relative"
            >
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center z-10 ${
                  isCompleted
                    ? "bg-primary1 text-white"
                    : isActive
                      ? "bg-yellow-400 text-white"
                      : "bg-gray-200 text-gray-500"
                }`}
              >
                {isCompleted ? (
                  <span className="text-lg font-semibold">✓</span>
                ) : isActive ? (
                  <LuClock className="text-lg text-white" />
                ) : (
                  <span className="text-base font-semibold">{stepNum}</span>
                )}
              </div>

              {index < steps.length - 1 && (
                <div
                  className={`absolute left-1/2 top-5 h-[2px] w-full -translate-y-1/2 ${
                    isCompleted ? "bg-primary1" : "bg-gray-200"
                  }`}
                ></div>
              )}

              <div
                className={
                  "whitespace-nowrap text-xs mt-1 " +
                  (isActive ? "text-black" : "text-gray-400")
                }
              >
                {label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ChangeConfirmationRequestProgress;
